<style src="vue-select/dist/vue-select.css"></style>
<style>
.table-hover {
    width: 100%;
    table-layout: fixed;
}

.table-sm {
    font-size: 14px;
}
</style>

<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">REKAP CLOSING</h3>

                        </div>

                        <div class="card-body table-responsive p-2">
                            <template>
                                <div class="col-sm-6">
                                    <div class="form-group mb-2">
                                        <MonthPicker v-model="filter.periode" label="Periode" @input="onFilterChange"
                                            class="custom-input" />
                                    </div>
                                    <div class="form-group mb-2">
                                        <KantorCabang v-model="filter.kantor" label="Cabang" @input="onFilterChange"
                                            class="custom-input" />
                                    </div>
                                </div>
                            </template>

                            <div class="col-sm-12 col-md-12">
                                <v-data-table :headers="headers" :items="users" :loading="loading"
                                    :items-per-page="pagination.itemsPerPage" :page.sync="pagination.page"
                                    :server-items-length="totalItems"
                                    :footer-props="{ itemsPerPageOptions: [50, 100, 200] }" @update:page="fetchUsers"
                                    @update:items-per-page="changeItemsPerPage">
                                    <template #item.no="{ item, index }">
                                        {{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}
                                    </template>
                                    <template #item.total_invoice="{ item }">
                                        <div class="text-center">
                                            {{ item.total_invoice }}
                                        </div>
                                    </template>
                                    <template #item.total_paid="{ item }">
                                        <div class="text-right">
                                            {{ formatRupiah(item.total_paid) }}
                                        </div>
                                    </template>
                                    <template #item.bulan_pemakaian="{ item }">
                                        <div class="text-center">
                                            {{ item.bulan_pemakaian }}
                                        </div>
                                    </template>
                                    <template #item.actions="{ item }">
                                        <div class="text-center">

                                            <button class="btn btn-xs btn-info" title="Detail rekap"
                                                @click="openUserDetail(item)">
                                                <i class="fas fa-search"></i>
                                            </button>
                                        </div>
                                    </template>
                                    <template v-slot:body.append>
                                        <tr class="font-weight-bold bg-light">
                                            <td colspan="2" class="text-center" style="font-size: 18px !important;">TOTAL</td>
                                            <td class="text-center" style="font-size: 18px !important;">{{ totalInvoice }}</td>
                                            <td class="text-right" style="font-size: 18px !important;">{{ formatRupiah(totalPaid) }}</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </div>
                        </div>

                    </div>
                    <!-- /.card -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import { formatRupiah } from '../../helpers/format'
import MonthPicker from '../../base-components/MonthPicker.vue'
import KantorCabang from '../../base-components/KantorCabang.vue'
import { EventBus } from './../../event-bus'
import Detail_Rekap_closing from './Detail_Rekap_closing.vue'
export default {

    components: {
        MonthPicker,
        KantorCabang,
    },
    data() {
        return {
            modal: {
                open: false,
                title: '',
                component: null,
                props: {},
                width: '1200px'
            },
            filter: {
                periode: new Date().toISOString().slice(0, 7),
                kantor: null
            },
            user: this.$gate.user,
            users: [],
            totalItems: 0,
            loading: false,
            pagination: {
                page: 1,
                itemsPerPage: 50
            },
            headers: [
                { text: 'No', value: 'no', sortable: false, width: '30px', align: 'center' },
                { text: 'User', value: 'name', sortable: true, width: '50%' },
                { text: 'Jumlah Invoice', value: 'total_invoice', sortable: true, class: 'text-center', width: '100px' },
                { text: 'Total PAID', value: 'total_paid', sortable: true, class: 'text-right', width: '100px' },
                { text: 'Periode Invoice', value: 'bulan_pemakaian', sortable: true, class: 'text-center', width: '100px' },
                { text: 'Aksi', value: 'actions', sortable: false, class: 'text-center', width: '40px' }
            ]
        }
    },
    computed: {
        totalInvoice() {
            return this.users.reduce((sum, item) => {
                return sum + Number(item.total_invoice || 0)
            }, 0)
        },

        totalPaid() {
            return this.users.reduce((sum, item) => {
                return sum + Number(item.total_paid || 0)
            }, 0)
        }
    },
    mounted() {
        this.fetchUsers()
    },
    methods: {
        openUserDetail(item) {
    EventBus.$emit('modal:show', {
        title: `Detail Rekap Closing Invoice [${item.name}]`,
        component: Detail_Rekap_closing,
        props: { 
            data: {
                status_bayar_by: item.status_bayar_by, // atau field yang sesuai
                periode: this.filter.periode,
                kantor_id: this.filter.kantor?.id || null // dari FILTER, bukan item
            }
        },
        width: '1200px',
        key: `${Date.now()}`
    })
},
        onFilterChange() {
            console.log('periode berubah:', this.filter.periode);
            this.pagination.page = 1;
            this.fetchUsers();
        },
        formatRupiah,
        async fetchUsers() {
            this.loading = true
            try {
                const bulan = this.filter.periode;
                const res = await axios.get('api/keuangan/rekap_closing', {
                    params: {
                        page: this.pagination.page,
                        per_page: this.pagination.itemsPerPage,
                        periode: bulan,
                        kantor_id: this.filter.kantor?.id || null
                    }
                })

                this.users = res.data.data
                this.totalItems = res.data.total
            } catch (e) {
                console.error(e)
            } finally {
                this.loading = false
            }
        },
        changeItemsPerPage(perPage) {
            this.pagination.itemsPerPage = perPage
            this.pagination.page = 1
            this.fetchUsers()
        }
    }
}
</script>